export default "<!-- header -->\n<app-ent-header></app-ent-header>\n\n<router-outlet></router-outlet>\n\n<!-- footer -->\n<app-ent-footer></app-ent-footer>\n"